import React from 'react';
import { motion } from 'framer-motion';
export function SlideLeadQuality() {
  const leads = [{
    name: 'Verena Behnke',
    company: 'ITM',
    role: 'Non-clinical Study Manager',
    why: 'Relevant non-clinical development profile from a radiopharma company.'
  }, {
    name: 'Sascha Frölich',
    company: 'Nuclidium',
    role: 'Sr Field Engineer',
    why: 'Technical profile from a radiopharma innovation company.'
  }, {
    name: 'Maria Saliakoura',
    company: 'Novartis',
    role: 'Principal Scientist',
    why: 'Scientific lead from a major global pharma player active in radioligand therapy.'
  }, {
    name: 'Benjamin Blehm',
    company: 'Darya Pharmaceuticals',
    role: 'CEO',
    why: 'Senior decision-maker from a specialist development/CRO-related company.'
  }, {
    name: 'Philippe Van Put',
    company: 'Full-Life',
    role: 'GM',
    why: 'Senior management profile from a radiotherapeutics company.'
  }, {
    name: 'Jeff Cleland',
    company: 'Ironfist Therapeutics',
    role: 'Interim CEO',
    why: 'Executive-level lead from an emerging therapeutic company.'
  }, {
    name: 'Seon A Jeon',
    company: 'SK Biopharmaceuticals',
    role: 'Scientist',
    why: 'Scientific profile from a major biopharma company.'
  }, {
    name: 'George Pope',
    company: 'Blue Earth Diagnostics',
    role: 'Director, Nonclinical & Translational Sciences',
    why: 'Highly relevant translational and non-clinical profile from molecular imaging/radiopharma space.'
  }, {
    name: 'Thomas Beale',
    company: 'Full-Life Technologies',
    role: 'AVP, CMC',
    why: 'Highly relevant CMC profile aligned with development, manufacturing, and supply reliability.'
  }, {
    name: 'Deb Nguyen',
    company: 'Photinia',
    role: 'Acting President',
    why: 'Senior executive lead from an emerging biotech/radiopharma-relevant company.'
  }, {
    name: 'Andreas',
    company: 'Actithera',
    role: 'CEO',
    why: 'CEO-level lead from a radioligand therapy company.'
  }, {
    name: 'Fang Jia',
    company: 'Solve Tx',
    role: 'Director, Radiopharmaceutical Manufacturing',
    why: 'Directly relevant manufacturing profile aligned with radiopharma execution and supply themes.'
  }];
  const groups = [{
    title: 'Strategic accounts',
    items: 'Novartis, ITM, Blue Earth Diagnostics, SK Biopharmaceuticals'
  }, {
    title: 'Radiopharma innovators',
    items: 'Nuclidium, Full-Life, Actithera, Ironfist, Photinia'
  }, {
    title: 'Senior decision-makers',
    items: 'CEO, GM, Interim CEO, Acting President'
  }, {
    title: 'Relevant technical functions',
    items: 'Non-clinical, translational, CMC, manufacturing, scientific roles'
  }];
  return <div className="flex flex-col h-full max-w-[1600px] mx-auto w-full" data-id="element-807">
      <div className="mb-4 text-center" data-id="element-808">
        <h2 className="text-3xl font-display font-bold text-slate-900 mb-1" data-id="element-809">
          12 leads — but the right 12
        </h2>
        <p className="text-base text-slate-500" data-id="element-810">
          A high-relevance lead harvest from the radiopharma development
          ecosystem
        </p>
      </div>

      {/* Table — scrollable so all 12 leads are reachable */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-811">
        <div className="grid grid-cols-12 gap-3 px-4 py-2.5 bg-slate-900 text-white text-[11px] font-bold uppercase tracking-wider" data-id="element-812">
          <div className="col-span-2" data-id="element-813">Lead</div>
          <div className="col-span-2" data-id="element-814">Company</div>
          <div className="col-span-3" data-id="element-815">Role / Title</div>
          <div className="col-span-5" data-id="element-816">Why it matters</div>
        </div>
        <div className="max-h-[44vh] sm:max-h-[320px] overflow-y-auto show-scroll" data-id="element-817">
          {leads.map((lead, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -8
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.1 + i * 0.035
        }} className={`grid grid-cols-12 gap-3 px-4 py-2 text-[11px] items-center border-b border-slate-100 ${i % 2 === 1 ? 'bg-slate-50/60' : ''}`} data-id="element-818">
              <div className="col-span-2 font-bold text-slate-800" data-id="element-819">
                {lead.name}
              </div>
              <div className="col-span-2 font-semibold text-slate-700" data-id="element-820">
                {lead.company}
              </div>
              <div className="col-span-3 text-slate-600 leading-tight" data-id="element-821">
                {lead.role}
              </div>
              <div className="col-span-5 text-slate-500 leading-tight" data-id="element-822">
                {lead.why}
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Grouping strip */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.7
    }} className="mt-4 grid grid-cols-4 bg-minerva-blue/5 border border-minerva-blue/20 rounded-xl overflow-hidden" data-id="element-823">
        {groups.map((g, i) => <div key={i} className={`px-4 py-3 text-center ${i < groups.length - 1 ? 'border-r border-minerva-blue/15' : ''}`} data-id="element-824">
            <div className="text-xs font-bold text-minerva-dark mb-1" data-id="element-825">
              {g.title}
            </div>
            <div className="text-[10px] text-slate-500 leading-snug" data-id="element-826">
              {g.items}
            </div>
          </div>)}
      </motion.div>

      {/* Takeaway */}
      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.9
    }} className="mt-4 text-center text-sm font-bold text-slate-800 max-w-4xl mx-auto leading-relaxed" data-id="element-827">
        This was not a volume play. It was a relevance play — a focused group of
        people close to the development, manufacturing, translation, and
        partnership challenges Minerva can help solve.
      </motion.p>
    </div>;
}